import Colors from '../../../../shared/assets/style/default/color';
import styled from 'styled-components';

const ModalContainer = styled.div<{ hideBackground?: boolean }>`
  background: ${(props) =>
    props.hideBackground ? '' : Colors['modal']['background']};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2;
`;

export default ModalContainer;
